import {Writable} from 'stream'
import {useEffect, useState} from 'react'

const defaultHookOptions = {endStream: false}

export const useStateStream = (stream, defaultValue, options) => {
  options = Object.assign({}, defaultHookOptions, options)
  if (defaultValue == null && stream.currentValue != null) {
    defaultValue = stream.currentValue
  }
  const [value, setValue] = useState(defaultValue)
  useEffect(() => {
    const sink = Writable({
      objectMode: true,
      write: (data, enc, next) => {
        if (data !== value) { setValue(data) }
        next()
      }
    })
    stream.pipe(sink)

    // cleanup
    return () => {
      stream.unpipe(sink)
      if (options.endStream) { stream.end() }
      sink.end()
    }
  }, [stream])
  return value
}

export const streamSetter = (stream, context, property, options) => {
  options = Object.assign({}, defaultHookOptions, options)
  const sink = Writable({
    objectMode: true,
    write: (data, enc, next) => {
      context[property] = data
      next()
    }
  })
  stream.pipe(sink)

  // cleanup
  return () => {
    stream.unpipe(sink)
    if (options.endStream) { stream.end() }
    sink.end()
  }
}

const $streamDestructors = Symbol('Stream Destructors')

export const facadeStreamSetter = (stream, facade, property, options) => {
  options = Object.assign({}, defaultHookOptions, options)
  const sink = Writable({
    objectMode: true,
    write: (data, enc, next) => {
      facade.update({[property]: data})
      next()
    }
  })
  stream.pipe(sink)

  if (!facade[$streamDestructors]) {
    facade[$streamDestructors] = []
    const oldDestructor = typeof facade.destructor === 'function'
      ? facade.destructor.bind(facade) : () => {}
    facade.destructor = () => {
      facade[$streamDestructors].forEach(d => d())
      oldDestructor()
    }
  }
  facade[$streamDestructors].push(() => {
    stream.unpipe(sink)
    if (options.endStream) { stream.end() }
    sink.end()
  })
}
